import { IconButton, Stack } from "@mui/material";
import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import KeyboardArrowLeftRounded from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowRightRounded from "@mui/icons-material/KeyboardArrowRightRounded";
import { colors } from "../constants/designTokens";
import { formatMonthYearLabel } from "../utils/formatters";
import FilterSelect from "./FilterSelect";

const iconButtonSx = {
  width: 36,
  height: 36,
  borderRadius: 2,
  bgcolor: colors.surface,
  border: `1px solid ${colors.border}`,
  boxShadow: "0 6px 16px rgba(23, 39, 70, 0.06)",
  "&:hover": { bgcolor: colors.surfaceAlt },
};

export default function PeriodSelector({
  months = [],
  value,
  onChange,
  minWidth = 112,
}) {
  if (!months.length) {
    return null;
  }

  const currentIndex = months.indexOf(value);
  const resolvedIndex = currentIndex >= 0 ? currentIndex : months.length - 1;
  const activeValue = months[resolvedIndex];

  const options = months.map((item) => ({
    value: item,
    label: formatMonthYearLabel(item),
  }));

  function handlePrevious() {
    if (resolvedIndex > 0) {
      onChange(months[resolvedIndex - 1]);
    }
  }

  function handleNext() {
    if (resolvedIndex < months.length - 1) {
      onChange(months[resolvedIndex + 1]);
    }
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.8} sx={{ my: 1.3, flexWrap: "wrap" }}>
      <IconButton sx={iconButtonSx} onClick={handlePrevious} disabled={resolvedIndex <= 0}>
        <KeyboardArrowLeftRounded />
      </IconButton>
      <FilterSelect
        value={activeValue}
        onChange={onChange}
        options={options}
        placeholder="Selecione o mes"
        icon={CalendarMonthOutlined}
        minWidth={minWidth}
        height={36}
        borderRadius={2}
      />
      <IconButton
        sx={iconButtonSx}
        onClick={handleNext}
        disabled={resolvedIndex >= months.length - 1}
      >
        <KeyboardArrowRightRounded />
      </IconButton>
    </Stack>
  );
}
